/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:4b9de3d5-80c0-473e-a05e-1b23d7efb566",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_gvcNKBRzV",
    "aws_user_pools_web_client_id": "5ulj5e3qnmfin8i0nm44k4eh62",
    "oauth": {
        "domain": "amplifycongitoauth-axa-amfs-id.auth.ap-southeast-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://idcxhhujjfd7joviboxe2fclfe.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cloud_logic_custom": [
        {
            "name": "GetProductsRestAPI",
            "endpoint": "https://3xizr5kqq9.execute-api.ap-southeast-1.amazonaws.com/master",
            "region": "ap-southeast-1"
        }
    ],
    "aws_content_delivery_bucket": "awsdrtool-hostingbucket-422661660555-ap-southeast-1-master",
    "aws_content_delivery_bucket_region": "ap-southeast-1",
    "aws_content_delivery_url": "https://d1fa502ta1u41o.cloudfront.net"
};


export default awsmobile;
